import { mapActions } from "vuex";

export default  {
	created () {    
	   
	},
	methods: 
    {	
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				let savePost=false
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{						
						case 'anularRegistroFtn':
							const await0 = this.updateDataPost({ state: 'tablaPost', data:  ['info_aportes','aportes_registro','archivo_plano','servicios_activos','info_afiliacion']})
							const await1 = this.updateDataPost({ state: 'tablaDelete', data: ['info_aportes','aportes_registro','archivo_plano']})
							const await2 = this.updateDataPost({ state: 'route', data: 'save_all'})
							const await3 = this.updateDataPost({ state: 'tablaAuditar', data: true})
							const await4 = this.updateDataPost({ state: 'notaDelete', data: this.dataForm[this.namePath].info_aportes.nota_delete})	
							
							await Promise.all([await0,await1,await2,await3,await4])
							
							savePost=true
							 
						break;
						case 'descargarAflFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaAuditar: true, 
									notaDelete: null, 
									tablaPost: ['info_aportes'],
									tablaDelete:[]
								}
							}) 	
						break;	
						case 'registroFtn': 
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaAuditar: true, 
									notaDelete: null, 
									tablaPost: ['info_aportes'],
									tablaDelete:[]
								}
							}) 
						break;
					}
				}

				let dataSave = await this.save(event.save,savePost)

				if(event.ftn==='registroFtn')
				{
					window.open( this.url+'/api/pdf/registroaportes?id='+dataSave.ids.info_aportes.toString()+'&token='+this.token,'_blank')					
				}
				
				const await30 =   this.getDataGet({route: 'get_aportesregistros', data: {inicial: this.filter.inicial, final: this.filter.final, others: []}})
				// frotend await this.searchIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
				const await31 =  this.resetDataIndex()
				const await32 =  this.resetGlobal({state: 'openModal'})
				const await33 =  this.resetDataForm()
				const await34 =  this.resetGlobal({state: 'saveConfig/capa'}) 
				await await30
				await await31
				await await32
				await await33
				await await34
			}
			catch(e){
				console.log(e)

			}			
		}		
	},
}
